import { VisibilityOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from '@mui/material';
import { Base64Image } from '../../../../utils/settings';
import { getPancardImageAction, AddBeneficiaryAction } from '../APIs/action';
import { toast } from 'react-toastify';
import React from 'react';
import { calculateAgesAndFlags, getAge } from '../../../Utils/AgeCalc';
import { useNavigate } from 'react-router-dom';
import { InsuranceType } from '../constants';

const ExistingBeneficiaryCard = ({
  beneficiary,
  benefitType,
  owner_type_text,
  selectedCompanyEntity,
  handleSubmit
}) => {
  const navigate = useNavigate();
  const [submitLoader, setSubmitLoader] = React.useState(false);

  const handleConfirm = async () => {
    const calculatedAge = beneficiary.dob
      ? calculateAgesAndFlags([beneficiary.dob])[0].age
      : '';

    const payload = {
      firm_owner_name: beneficiary.firm_owner_name,
      id_type: beneficiary.id_type,
      id_number: beneficiary.id_number,
      insurance_id: benefitType,
      full_name: beneficiary.full_name || '',
      dob: beneficiary.dob,
      age: calculatedAge,
      phone_number: beneficiary.phone_number,
      relation: beneficiary.relation,
      firm_type: owner_type_text?.value || '',
      gender: beneficiary.gender || '',
      company_esi_id: selectedCompanyEntity || '',
    };

    setSubmitLoader(true);
    try {
      const response = await AddBeneficiaryAction(payload);
      setSubmitLoader(false);
      const { data, error, message } = response;
      if (!error) {
        toast.success(message || 'Beneficiary added successfully');
        if (benefitType === InsuranceType.LIFE_INSURANCE) {
          navigate('/beneficiary/add-nominee', {
            state: {
              insurance_type: benefitType,
              beneficiary_id: data?.beneficiary_id,
              selectedCompanyEntity: selectedCompanyEntity
            },
          });
        } else if (benefitType === InsuranceType.MEDICAL_INSURANCE) {
          navigate('/beneficiary/detail', {
            state: {
              insurance_type: benefitType,
              selectedCompanyEntity: selectedCompanyEntity
            },
          });
        }
      } else {
        toast.error(message || 'Failed to add beneficiary');
      }
    } catch (error) {
      setSubmitLoader(false);
      toast.error('An error occurred while adding beneficiary');
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#FFF',
        borderRadius: 2,
        p: 2,
        gap: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant='body1'
        sx={{ fontWeight: 700, fontSize: '16px', lineHeight: '24px' }}
      >
        Beneficiary Details
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2}}>
        <DetailField
          label='Name'
          value={beneficiary?.full_name || '-'}
        />
        <DetailField
          label='D.O.B'
          value={beneficiary?.dob || '-'}
        />
        <DetailField
          label='Gender'
          value={beneficiary?.gender || '-'}
        />
        <DetailField
          label="Age"
          value={beneficiary?.dob ? `${getAge(beneficiary.dob)}y` : '-'}
        />
        <DetailField
          label='Relation'
          value={beneficiary?.relation || '-'}
        />
        <DetailField
          label='Mobile No'
          value={beneficiary?.phone_number || '-'}
        />
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            const calculatedAge = beneficiary?.dob ? getAge(beneficiary.dob) : 0;
            handleSubmit({
              ...beneficiary,
              age: calculatedAge
            });
          }}
          disabled={submitLoader}
          sx={{
            textTransform: 'none',
            width: '100%',
          }}
        >
          {submitLoader ? (
            <CircularProgress
              size={20}
              sx={{ color: 'white' }}
            />
          ) : (
            'Confirm'
          )}
        </Button>
      </Box>
    </Box>
  );
};
const DetailField = ({ label, value, handleViewImage, panImageError }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'right',
    }}
  >
    <Typography
      variant='labelD'
      sx={{ color: '#666666'}}
    >
      {label}
    </Typography>
    <Typography variant='body1' sx={{ color: '#333333' }}>
      {value}
    </Typography>
  </Box>
);
const DetailFieldWithImage = ({
  openImage,
  selectedImage,
  handleClose,
  loader,
}) => (
  <Dialog
    open={openImage}
    onClose={handleClose}
    maxWidth='sm'
  >
    <DialogContent sx={{ textAlign: 'center' }}>
      {loader ? (
        <CircularProgress sx={{ color: '#FFA525', fontSize: '30px' }} />
      ) : (
        selectedImage && (
          <Base64Image
            base64String={selectedImage}
            style={{ width: '300px', marginBottom: '10px' }}
          />
        )
      )}
    </DialogContent>
  </Dialog>
);

export default ExistingBeneficiaryCard;
